import {Component, OnDestroy} from '@angular/core';
import {constants} from "../../../constants";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-mobile-apps-banner',
  templateUrl: './mobile-apps-banner.component.html',
  styleUrls: ['./mobile-apps-banner.component.css']
})
export class MobileAppsBannerComponent implements OnDestroy {
  protected readonly constants = constants;
  private readonly utmParamsSubscription: Subscription;
  private utmParams: string;
  googleLink: string;
  appleLink: string;
  huaweiLink: string

  constructor(private route: ActivatedRoute) {
    this.utmParamsSubscription = this.route.queryParams.subscribe(params => {
      this.utmParams = Object.keys(params)
        .filter(key => key.startsWith('utm_'))
        .map(key => `${key}=${params[key]}`)
        .join('&');
      this.updateLinks();
    });
  }

  private updateLinks(): void {
    this.appleLink = this.getAppleUrl();
    this.googleLink = this.getGoogleUrl();
    this.huaweiLink = this.getHuaweiUrl();
  }

  private getAppleUrl(): string {
    return this.utmParams ? `${constants.appStoreLink}?${this.utmParams}` : constants.appStoreLink;
  }

  private getGoogleUrl(): string {
    return this.utmParams ? `${constants.googlePlayLink}?${this.utmParams}` : constants.googlePlayLink;
  }

  private getHuaweiUrl(): string {
    return this.utmParams ? `${constants.appGalleryLink}?${this.utmParams}` : constants.appGalleryLink;
  }

  ngOnDestroy(): void {
    this.utmParamsSubscription.unsubscribe();
  }
}
